
<div class="row box-container" *ngIf="!noDataAvailable">
  <div class="col-sm-12">
    <span class="title">{{'INFLUENCER.CHART.TOP_10_BRAND_MENTIONS' | translate}}</span>
    <achoo-icon-tooltip [tooltipMsg]="'info_box.influencer.top_mentions' | translate"></achoo-icon-tooltip>
  </div>
  <div class="col-6">
    <div class="row item align-items-center" *ngFor="let item of left; let i = index;">
      <div class="col-1 index">{{i + 1}}.</div>
      <div class="col-3 ellipsis mention">{{item.keyword}}</div>
      <div class="d-flex justify-content-end bar-container">
        <div class="progress-bar" [style.width.%]="(item.number/left[0].number)*100" [style.backgroundColor]="bgColor"></div>
      </div>
      <div class="d-flex justify-content-end number" *ngIf="!isFallbackView">{{item.number}}</div>
      <div class="d-flex justify-content-end number" *ngIf="isFallbackView">
        <div class="fallback-view-number-item"></div>
      </div>
    </div>
  </div>
  <div class="col-6 right-side">
    <div class="row item align-items-center" *ngFor="let item of right; let i = index;">
      <div class="col-1 index">{{i + left.length + 1}}.</div>
      <div class="col-3 ellipsis mention">{{item.keyword}}</div>
      <div class="d-flex justify-content-end bar-container">
        <div class="progress-bar" [style.width.%]="(item.number/left[0].number)*100" [style.backgroundColor]="bgColor"></div>
      </div>
      <div class="d-flex justify-content-end number" *ngIf="!isFallbackView">{{item.number}}</div>
      <div class="d-flex justify-content-end number" *ngIf="isFallbackView">
        <div class="fallback-view-number-item"></div>
      </div>
    </div>
  </div>
</div>
<div class="row" *ngIf="noDataAvailable">
  <div class="col-md-12">
    <top-mention-placeholder></top-mention-placeholder>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/main/influencer/top-mention/top-mention.component.html